// extracted by mini-css-extract-plugin
export default {"products":"ew-z","card":"fw-z","oosMessaging":"gw-z"};